import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [],total:0,error: "", message: "" }



export const singlePendingTransactionAction = createAsyncThunk(
    'single-pending-transaction',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/single-pending-transaction/${data.trans_id}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const singlePendingTransactionSlice = createSlice({
    name: 'single-pending-transaction',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(singlePendingTransactionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(singlePendingTransactionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalData
            })
            builder.addCase(singlePendingTransactionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalData

            })
        },

})



export const singlePendingTransactionReducer = singlePendingTransactionSlice.reducer